import { TypedTypePolicies } from "../graphql/apolloHelpers";

export const typePolicies: TypedTypePolicies = {
  ServicePeriod: {
    keyFields: ["code"],
  },
};
